import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import myLibraryActions from 'redux/actions/my_library_actions'
import { localize } from 'helpers/translator'

const MyLibraryExportToPDFConfirm = props => (
	<Confirm
		btOne={localize('my_library_export_pdf_google_drive')}
		btTwo={localize('my_library_export_pdf_local_drive')}
		alertMessage={localize('my_library_export_pdf_message')}
		actionButtonType={0}
		actionOne={() => {
			props.actions.exportToGoogleDrive(props.lesson)
		}}
		actionTwo={() => {
			props.actions.exportToLocalDrive(props.lesson)
		}}
		closeAction={() => {
			props.actions.closeExportToPDFConfirm()
		}}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeExportToPDFConfirm: myLibraryActions.closeExportToPDFConfirm,
		exportToGoogleDrive: myLibraryActions.exportToGoogleDrive,
		exportToLocalDrive: myLibraryActions.exportToLocalDrive,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(MyLibraryExportToPDFConfirm)
